import parse from 'html-react-parser';

export const newLineParser = (str: string) => {
  const s = (str || '').replaceAll('\n', '<br />');
  return parse(s);
};
